function openTabs() {
    let tabcontent, tablinks;
    tablinks = document.querySelectorAll(".tabbedItems__button");
    if (tablinks.length) {
        for (let i = 0; i < tablinks.length; i++) {
            tablinks[i].addEventListener("click", function() {
                var current = document.getElementsByClassName("active");
                current[0].className = current[0].className.replace(" active", "");
                this.className += " active";

                tabcontent = document.getElementsByClassName("tabbedItems__tabContent");
                for (let i = 0; i < tabcontent.length; i++) {
                    tabcontent[i].style.display = "none";
                }
                let id = tablinks[i].getAttribute("data-id");
                let content = document.getElementById(id);
                content.style.display = "block";
            });
        }
    }
}

function init() {
    openTabs();
}

export default { init };
